import "./Text.css";

const Text = function () {
  return (
    <div className="text__para-box">
      <p className="text__para">
        Never Use Youtube Just For the Fun , Now You are thinking what is going
        to happen after watching just one video , let's just enjoy for 5 min.
        Please Remove these thought from your mind. If you invest 5 minute in
        productive work then your life will definately change.
      </p>
    </div>
  );
};

export default Text;
